/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import WakeboardSpecs from "./wakeboard-specs";
// @ts-ignore
import FatsacSpecs from "./fatsac-specs";
// @ts-ignore
import {GetLocalText} from "./../../themes/kent/utilities/functions";
// @ts-ignore
import {GeneralAssetUrl} from "./../../themes/kent/utilities/constants";

interface IState {}

interface IProps {
  product?: any;
  parentProduct?: any;
  year?:any;
  forceBrandColor?:any;
}

/**
 *
 * Sizes component
 * @extends {React.PureComponentReact.Component<IProps,IState>}
 */

class Specs extends React.Component<IProps,IState> {
  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  public render(): JSX.Element {
    let product = this.props.product;
    if(this.props.parentProduct){
      product = this.props.parentProduct;
    }
    return (
      <div>
      {this.props.product.attributes.subcategory == "g7lQZjE06q" && <FatsacSpecs product={product} year={this.props.year} />}
				{(product.attributes.slug == "wakesurfers-accelerator" || product.attributes.slug == "wakesurfers-raygun" || product.attributes.slug == "wakesurfers-trifecta-blank" || product.attributes.slug == "wakesurfers-exacta-blank") &&
					<div className="tiny-padding centered-text">
						<div className="tiny-padding white-background shadow small-max-width-container" style={{maxWidth:'400'}}>
							<p className="black"><b>{'Warranty Not Available'}</b></p>
							<p className="subheading">{'Due to the advanced nature of the Varial Surf Program, Warranty is not available.'}</p>
							<p><span className="subheading">{'For repair options visit the'}</span> <a target="_blank" href="https://shop.varialsurf.com/repair-s/120.html">{'Varial Surf Repair Shop'}</a><span className="subheading">{'.'}</span></p>
						</div>
					</div>
				}
				{product.attributes.category == "tYeyYbLaJ5" && <WakeboardSpecs product={this.props.product} year={this.props.year} forceBrandColor={this.props.forceBrandColor} />}
			</div>
    );
  }
}

export default Specs;
